import React from 'react'

const Notifcation = () => {
  return (
    <div>Notifcation</div>
  )
}

export default Notifcation